module.exports = __webpack_public_path__ + "img/3.e44130f9.jpg";